import * as yup from "yup";

export const commitmentCreateSchema = yup
  .object()
  .shape({
    owning_entity_id: yup.string().required(),
    owned_entity_id: yup.string().required(),
    investor_class_id: yup.string().required(),
    commitment_amount: yup.string().max(256).required(),
  })
  .required();
